<script lang="ts">
    import type { AuthenticationDetailsCarrier } from "@app/models/api";
    import { doFetch } from "@app/services/http-client";
    import Loading from "../Icons/Loading.svelte";
    import NotificationsController from "./NotificationsController.svelte";
    import NotificationsMarker from "./NotificationsMarker.svelte";
    import { unreadMessages, updateUnreadMessagesCount } from "./NotificationsService";
    const navbarNotificationsContainer = document.getElementById(
        "navbar_notifications"
    );
    let auth: Promise<AuthenticationDetailsCarrier>;
    if (navbarNotificationsContainer) {
        new NotificationsMarker({
            target: navbarNotificationsContainer,
        });
        updateUnreadMessagesCount();
    }

    const notificationsContrainer = document.getElementById("notificationsContainer");
    if (notificationsContrainer) {
        new NotificationsController({target: notificationsContrainer});
    }
</script>
